import { useContext } from 'react';
import { ClothesContext } from '@Pages/Clothes/context';

export default function Component() {
  const { rows, page, setPage } = useContext(ClothesContext);

  return (
    <div className="mt-5 text-center">
      {Array.from(Array(rows), (e, i) => (
        <button
          key={i}
          className={`btn btn-pagination fw-semibold rounded-0 mx-3 ${
            page === i ? 'active' : ''
          }`}
          onClick={() => setPage((page) => i)}
        >
          {i + 1}
        </button>
      ))}
    </div>
  );
};